var map = {
	"./music-instructions.json": 4427,
	"./music-library-intro2024.json": 4428,
	"./music-library-launch2024.json": 4429,
	"./music-progression.json": 4430,
	"./startSourcesAdvanced.json": 4431,
	"./startSourcesSimple.json": 4432,
	"./startSourcesSimple2.json": 4433,
	"./startSourcesTracks.json": 4434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4162;